import { KeycloakService } from 'keycloak-angular';
import { AppConfigService } from '../services/app-config.service';

export function initializeKeycloak(keycloak: KeycloakService, configService: AppConfigService): () => Promise<boolean> {
  return async () => {
    await configService.load();
    return keycloak.init({
      config: {
        url: configService.keycloak.url,
        realm: configService.keycloak.realm,
        clientId: configService.keycloak.clientId
      },
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: true,
        checkLoginIframeInterval: 5,
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        enableLogging: true,
        pkceMethod: 'S256'
      },
      bearerExcludedUrls: ['/assets']
    });
  };
}
